import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js';

// Validation to ensure the text entered is of type phone number
export function phoneValidator(countryCode: () => string | string, relaxed?: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const country: string = typeof countryCode === 'string' ? countryCode : countryCode();

    if (!country) {
      console.error("countryCode didn't return a value");
      return;
    }

    try {
      if (!control.value) {
        return null;
      }
      const c = country as CountryCode;
      const pn = parsePhoneNumber(control.value, c);
      return relaxed ? (pn.isPossible() ? null : { phone: '' }) : pn.isValid() ? null : { phone: '' };
    } catch (e) {
      return { phone: '' };
    }
  };
}
